import { render } from "./_lang.vue?vue&type=template&id=4b146a5e"
import script from "./_lang.vue?vue&type=script&lang=js"
export * from "./_lang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__